import { FC } from "react";

import { Divider } from "antd";
import { useNavigate } from "react-router-dom";

import { Button } from "../../../customs";
import styles from "./notificationCard.module.css";
import { NotificationData } from "./type";
import { dateDifferenceInWords } from "../../../utils/date";

import { ReactComponent as NotiBell } from "../../../assets/svgs/notification-bell.svg";
import { ReactComponent as DotIcon } from "../../../assets/svgs/dot.svg";

interface ComponentProps {
  data: NotificationData[];
  onClick: (id: number) => void;
}

const NotificationCard: FC<ComponentProps> = ({ data, onClick }) => {
  const navigate = useNavigate();

  return (
    <>
      {data?.length > 0 ? (
        <div className={styles.container}>
          <div>
            <h2>Notification</h2>
          </div>

          <Divider className={styles.divider} />

          {data?.slice(0, 3)?.map((item, index) => (
            <div className={styles.content} key={item?.ActivityId}>
              <div onClick={() => onClick(item?.ActivityId)}>
                <NotiBell />

                <div className={styles.hoveringCircle}></div>

                <div>
                  <p>{item?.ActivityDescription}</p>
                  <div>
                    <p>{dateDifferenceInWords(new Date(item?.CreatedDate))}</p>
                    <DotIcon />
                    <p>Exam</p>
                  </div>
                </div>
              </div>

              {index !== data?.length - 1 && (
                <div className={styles.dividerContainer}>
                  <Divider className={styles.divider} />
                </div>
              )}
            </div>
          ))}

          <div className={styles.footer}>
            <Divider className={styles.divider} />

            <div className={styles.footerButton}>
              <Button
                variant="naked"
                color="#11643C"
                onClick={() => navigate("/notification")}
              >
                View all notification
              </Button>

              {/* <Button variant="naked" color="#11643C">
                Mark all as read
              </Button> */}
            </div>
          </div>
        </div>
      ) : (
        <div>No notification</div>
      )}
    </>
  );
};

export default NotificationCard;
